export const afterChangeReceivableAmountTips = '财务人员对款项应收金额变更后的实际应收金额。'
export const changeReceivableAmountTips = '1）对计划应收金额进行增减变更的金额，调高显示“+”，调低显示“-”。2）自动和手动关闭的应收金额都会自动记录为调低应收。'
export const receivingPayments = '剩余应收金额=变更后应收金额-已收金额-收款中金额'
